import { PureComponent } from 'preact-compat'
import { subscribeTopic, unsubscribeTopic, getSubscriptionStatus } from '../services/subscriptionService'

export interface SubscribeTopicProps {
  publicId: string
  onShowAlert: (type: 'success' | 'error', message?: string) => void
}

export interface SubscribeTopicState {
  subscribed: boolean
}

class SubscribeTopic extends PureComponent<SubscribeTopicProps, SubscribeTopicState> {
  constructor (props: SubscribeTopicProps) {
    super(props)
    this.state = {
      subscribed: false
    }
    this.onToggleSubscribe = this.onToggleSubscribe.bind(this)
  }

  async componentDidMount() {
    const { publicId } = this.props
    const subscribed = await getSubscriptionStatus(publicId)
    this.setState({ subscribed })
  }

  async onToggleSubscribe () {
    const { publicId, onShowAlert } = this.props
    const { subscribed } = this.state

    try {
      if (subscribed) {
        await unsubscribeTopic(publicId)
      } else {
        await subscribeTopic(publicId)
      }
      this.setState((prevState) => ({
        subscribed: !prevState.subscribed
      }))
    } catch {
      onShowAlert('error')
    }
  }

  render () {
    const { subscribed } = this.state

    return (
      <div className='post--options-list-container-item'>
        <a data-qa='subscribe-topic' className={subscribed ? 'active' : ''} onClick={this.onToggleSubscribe}>
          <i className='fa fa-star' />{subscribed ? ' Unsubscribe' : ' Subscribe'}
        </a>
      </div>
    )
  }
}

export default SubscribeTopic
